export const API_HOST =  process.env.REACT_APP_API_HOST || (window as any).env?.api_url;
